import React, { useState, useRef, useCallback, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Form, {
  Item,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  CustomRule,
  Label,
  PatternRule,
} from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import { recoveryPassword, validateRecoveryCode } from "../../api/auth";
import { passwordRegex } from "../../common/regex";

export default function ChangePasswordForm() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const formData = useRef({});
  const { recoveryCode } = useParams();

  useEffect(() => {
    const validate = async () => {
      setLoading(true);

      const result = await validateRecoveryCode(recoveryCode);
      setLoading(false);

      if (!result.isOk) {
        notify("Invalid recovery code", "error", 2000);
        history.push("/login");
        return;
      }
      return;
    };
    validate();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { password } = formData.current;
      setLoading(true);

      const result = await recoveryPassword(password, recoveryCode);
      setLoading(false);

      if (result.isOk) {
        history.push("/login");
      } else {
        notify(result.message, "error", 2000);
      }
    },
    [history, recoveryCode]
  );

  const confirmPassword = useCallback(
    ({ value }) => value === formData.current.password,
    []
  );

  return (
    <form className={"login-form"} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading} labelLocation="top">
        <Item
          dataField={"password"}
          editorType={"dxTextBox"}
          editorOptions={passwordEditorOptions}
        >
          <Label text="New password" />
          <RequiredRule message="Password is required" />
          <PatternRule
            message="Password must contain at least 8 characters, including UPPER/lowercase and numbers"
            pattern={passwordRegex}
          />
        </Item>
        <Item
          dataField={"confirmedPassword"}
          editorType={"dxTextBox"}
          editorOptions={confirmedPasswordEditorOptions}
        >
          <Label text="Confirm new password" />
          <RequiredRule message="Password is required" />
          <CustomRule
            message={"Passwords do not match"}
            validationCallback={confirmPassword}
          />
        </Item>
        <ButtonItem cssClass="button-rounded mt-3">
          <ButtonOptions
            width={"100%"}
            type={"default"}
            stylingMode="outlined"
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width={"24px"} height={"24px"} visible={true} />
              ) : (
                "Change password"
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
        <Item>
          <div className={"login-link text-center"}>
            Return to <Link to={"/login"}>Sign In</Link>
          </div>
        </Item>
      </Form>
    </form>
  );
}

const passwordEditorOptions = { placeholder: "New password", mode: "password" };
const confirmedPasswordEditorOptions = {
  placeholder: "Confirm new password",
  mode: "password",
};
